import CustomCheckbox from "../../../../../components/CustomCheckbox";

const ParagraphList = ({
  worksheetTitle,
  worksheetData,
  activeParagraph,
  setActiveParagraph,
  selectedParagraphs,
  setSelectedParagraphs,
}) => {
  const isAllSelected =
    worksheetData.length > 0 &&
    worksheetData.every((_, i) => selectedParagraphs.includes(i));

  const handleParagraphClick = (index) => {
    setActiveParagraph(worksheetData[index]);
  };

  const handleCheckboxClick = (index) => {
    setSelectedParagraphs((prev) => {
      // 이미 선택돼 있으면 해제, 아니면 추가
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      // 모두 선택
      const allIndices = worksheetData.map((_, i) => i);
      setSelectedParagraphs(allIndices);
    } else {
      // 모두 해제
      setSelectedParagraphs([]);
    }
  };

  return (
    <div
      style={{
        width: "20%",
        borderRight: "1px solid #EBEBEB",
        padding: "20px",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          marginBottom: "5px",
        }}
      >
        출제 지문 선택
      </div>
      <div
        style={{
          fontSize: "16px",
          color: "#737373",
          marginBottom: "30px",
        }}
      >
        {worksheetTitle}
      </div>
      <div
        style={{
          padding: "10px 0px",
          marginBottom: "10px",
          display: "flex",
          borderBottom: "1px solid #EBEBEB",
        }}
      >
        <CustomCheckbox
          checked={isAllSelected}
          onChange={() => handleSelectAll(!isAllSelected)}
        />
        <div
          style={{
            marginLeft: "10px",
            color: isAllSelected ? "#000" : "#737373",
          }}
          onClick={() => handleSelectAll(!isAllSelected)}
        >
          전체 선택
        </div>
      </div>

      {/* Paragraph 리스트 */}
      {worksheetData.map((paragraph, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
            cursor: "pointer",
            backgroundColor:
              activeParagraph === worksheetData[index] ? "#f4f4f4" : "#fff",
          }}
          onClick={() => handleParagraphClick(index)}
        >
          {/* 체크박스 */}
          <CustomCheckbox
            checked={selectedParagraphs.includes(index)}
            onChange={(e) => {
              e.stopPropagation();
              handleCheckboxClick(index);
            }}
          />
          {/* paragraph 제목 (keypoints.title) */}
          <span
            style={{
              marginLeft: "10px",
              color: selectedParagraphs.includes(index) ? "#000" : "#737373",
            }}
          >
            {paragraph.title || `Paragraph ${index + 1}`}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ParagraphList;
